<template>
  <div class="container appointment-card">
    <div class="row">
      <div v-if="globalMode != 'past'">
        <div class="d-flex flex-column appointment-cell mx-0 px-1">
          <button
            :disabled="loading || appointment.status !== 'Show'"
            type="button"
            class="btn btn-outline-0 text-danger gap-dashboard"
            v-on:click="cancelAppointment"
          >
            <i class="fas fa-ban fa-sm mr-1"></i> Cancel
          </button>
        </div>
      </div>

      <div class="col">
        <div class="d-flex flex-column appointment-cell">
          <h6>Date:</h6>
          <h6 class="font-weight-bold">
            {{ appointment.appointmentDate | formatDateOnly() }}
          </h6>
        </div>
      </div>

      <div class="col">
        <div class="d-flex flex-column appointment-cell">
          <h6>Time:</h6>
          <h6 class="font-weight-bold">
            {{ appointment.appointmentDate | formatTimeOnly("hh:mm A") }}
          </h6>
        </div>
      </div>

      <div class="col">
        <div class="d-flex flex-column appointment-cell">
          <h6>Length:</h6>
          <h6 class="font-weight-bold">
            {{ appointment.appointmentLength | humanMillis }}
          </h6>
        </div>
      </div>

      <div class="col">
        <div class="d-flex flex-column appointment-cell">
          <h6>Provider:</h6>
          <h6 class="font-weight-bold">{{ appointment.provider }}</h6>
        </div>
      </div>

      <div class="col">
        <div
          class="d-flex flex-row justify-content-center align-items-center appointment-cell"
        >
          <b-badge
            pill
            class="form-badge"
            :style="{
              color: appointment.color,
              backgroundColor: backgroundColor
            }"
          >
            {{ appointment.status }}
          </b-badge>
        </div>
      </div>

      <div class="col-md-4">
        <div class="d-flex flex-row justify-content-center">
          <button
            type="button"
            class="btn btn-link btn-outline-primary gap-dashboard mr-3"
            v-on:click="joinTelehealthSession"
            :disabled="
              !joinMeeting ||
                globalMode === 'past' ||
                appointment.status !== 'Show'
            "
          >
            <i class="fas fa-chalkboard-teacher mr-1"></i> Join Session
          </button>
          <button
            :disabled="
              loading || globalMode === 'past' || appointment.status !== 'Show'
            "
            type="button"
            class="btn btn-checkedin py-1"
            :class="{
              'btn-success': appointment.checkedIn,
              'btn-outline-success': !appointment.checkedIn
            }"
            v-on:click="checkNextAppointment"
          >
            <i class="fas fa-check mr-1"></i>
            {{ appointment.checkedIn ? "Checked In" : "Check In" }}
          </button>
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lightenDarkenColor } from "../../helpers/general";
import scheduleEvent from "../../server/scheduleEvents";
import { billingServer } from "../../server/billing";
import { appointmentsServer } from "../../server/appointments";

import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    appointment: Object,
    globalMode: String
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions("appointments", ["loadAppointments"]),
    async checkNextAppointment() {
      var res = await scheduleEvent.isPatientOutstandingBalance(this.patientId);

      if (this.appointment.checkedIn) {
        this.checkAction();
        return;
      }

      if (res != "") {
        this.showPayBalanceWarning("checkNextAppointment");
      } else {
        this.checkAction();
      }
    },
    async checkAction() {
      this.loading = true;
      var result = await scheduleEvent.setCheckedIn(
        this.appointment.episodeOfCareId,
        {
          checkedIn: !this.appointment.checkedIn
        }
      );
      appointmentsServer.sendToMainApp(this.currentTenant, this.appointment.id, this.signalRAppUrl);
      this.appointment.checkedIn = result.checkedIn;
      this.loading = false;
    },
    goToMeetingUrl() {
      this.loading = true;
      var url = null;
      if (this.appointment.teamsMeetingUrl) {
        url = this.appointment.teamsMeetingUrl;
      }
      if (this.appointment.zoomMeetingUrl) {
        url = this.appointment.zoomMeetingUrl;
      }
      window.open(url, "_blank");
      this.loading = false;
    },
    async joinTelehealthSession() {
      var result = await scheduleEvent.isPatientOutstandingBalance(
        this.patientId
      );
      if (result != "") {
        this.showPayBalanceWarning("joinTelehealthSession");
      } else {
        this.goToMeetingUrl();
      }
    },
    async cancelAppointment() {
      var date = moment(String(this.appointment.appointmentDate)).format(
        "MM/DD/YYYY hh:mm a"
      );
      this.$dialog
        .confirm(
          {
            title: `Are you sure you want to cancel your appointment with ${this.appointment.provider} on ${date}?`
          },
          {
            view: "confirm-delete",
            removeButtonTitle: "Yes",
            cancelButtonTitle: "Close"
          }
        )
        .then(async () => {
          var result = await scheduleEvent.cancelAppointment(
            this.appointment.episodeOfCareId,
            this.appointment.id
          );
          this.appointment.status = result.scheduleEventStatus.name;
          appointmentsServer.sendToMainApp(
            this.currentTenant,
            this.appointment.id,
            this.signalRAppUrl
          );
          this.loadAppointments();
        });
    },
    async showPayBalanceWarning(action) {
      this.$dialog
        .confirm(
          {
            title:
              "Hello! <br/><br/> Your account currently has a balance. Please follow the prompts below to ensure you understand the cost of services and do not accumulate a large balance."
          },
          {
            view: "payment-options-confirm",
            options: [{ value: true, label: "Yes" }]
          }
        )
        .then(async option => {
          if (option.data == "payNow") {
            var response = await billingServer.getInvoices(this.patientId);
            this.$router.push({
              name: "InvoicePayment",
              params: {
                invoices: response.data,
                fromPaywall: true
              }
            });
          } else {
            action == "joinTelehealthSession"
              ? this.goToMeetingUrl()
              : this.checkAction();
          }
        })
        .catch(function() {});
    }
  },
  computed: {
    ...mapState("session", {
      patientId: state => state.user.PatientId,
      currentTenant: state => state.systemSettings.currentTenant,
      signalRAppUrl: state => state.systemSettings.signalRAppUrl
    }),
    backgroundColor() {
      return lightenDarkenColor(this.appointment.color, 85);
    },
    joinMeeting() {
      return (
        this.appointment.teamsMeetingUrl ||
        (this.appointment.zoomMeetingUrl && !this.loading)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-success,
.btn-warning {
  color: white !important;
}
.appointment-card {
  background-color: #f5f6f9;
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 1.5em;

  .appointment-cell {
    height: 100%;
    border-right: 2px #efeff2 solid;

    h6 {
      font-size: 0.8em;
      margin: 0;

      &:first-child {
        margin-bottom: 5px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .appointment-cell {
      border-right: none;
      margin-bottom: 1em;
    }
  }

  .form-badge {
    padding: 5px 10px;
    margin-right: 20px;
    font-size: 0.8em;
    width: 100%;
    max-width: 100px;

    &.completed {
      background: #ccf9cf;
      color: #01be0e;
    }

    &.pending {
      background: #fff3ca;
      color: #ffc300;
    }
  }

  .gap-dashboard {
    margin-right: 20px;
  }
}
</style>
